var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',{model:{value:(_vm.newMessage),callback:function ($$v) {_vm.newMessage=$$v},expression:"newMessage"}}),_c('el-button',{on:{"click":_vm.sendMessage}},[_vm._v("发送")]),_vm._l((_vm.messages),function(msg){return _c('div',{key:msg.id},[_vm._v(" "+_vm._s(msg.content)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }